<script lang="ts" setup>
import qrDevelopment from '@/assets/mobile-app-qr-development.svg';
import qrProduction from '@/assets/mobile-app-qr-production.svg';
import qrStaging from '@/assets/mobile-app-qr-staging.svg';
import { ANDROID_STORE_URL, IOS_STORE_URL } from '@/constants';
import { useIsNextLayout } from '@/utils/composables/useLayoutVariant';

const getQrImgPath = () => {
  switch (import.meta.env.VITE_ENV) {
    case 'development':
      return qrDevelopment;
    case 'staging':
      return qrStaging;
    default:
      return qrProduction;
  }
};

const iosUrl = IOS_STORE_URL;
const androidUrl = ANDROID_STORE_URL;
const qrImgPath = getQrImgPath();

const isNextLayout = useIsNextLayout();
</script>

<template>
  <div class="m-mobile-app-info" :class="{ 'no-margin': isNextLayout }">
    <div :class="isNextLayout ? 'c-title-bold--m' : 'c-text-regular--m'">
      アプリでもっと手軽に！
    </div>
    <div class="m-qr-code" :class="{ large: isNextLayout }">
      <img :src="qrImgPath" />
    </div>
    <div class="m-download-buttons">
      <a
        class="m-download-button ios"
        :href="iosUrl"
        target="_blank"
        rel="noopener noreferrer"
        ><img src="@/assets/app-download-apple.svg" /></a
      ><a
        class="m-download-button android"
        :href="androidUrl"
        target="_blank"
        rel="noopener noreferrer"
        ><img src="@/assets/app-download-google.png"
      /></a>
    </div>
    <div class="c-text-regular--xs note">
      Apple および Apple ロゴは米国その他の国で登録されたApple Inc. の商標です。
      App Store は Apple Inc. のサービスマークです。 Google Play および Google
      Play ロゴは、Google LLC の商標です。
    </div>
  </div>
</template>

<style lang="scss" scoped>
.m-mobile-app-info {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  margin-top: 16px;
  padding: 12px 16px 16px 16px;
  background: #fff;
  border: 1px solid $color-gray400;
  border-radius: 4px;

  &.no-margin {
    margin: 0;
  }

  .m-download-buttons {
    display: flex;
    .m-download-button {
      width: 88px;
      height: 32px;

      img {
        height: 100%;
        width: 100%;
      }

      &.android {
        width: 107px;
        margin-left: 8px;
      }
    }
  }

  .m-qr-code {
    height: 48px;
    width: 48px;
    padding: 12px 0;
    img {
      height: 100%;
      width: 100%;
    }

    &.large {
      width: 80px;
      height: 80px;
    }
  }

  .note {
    color: $color-gray600;
  }
}
</style>
